import { z } from 'zod';
export const UserAttributeTypeSchema = z.enum(['text', 'number', 'date', 'boolean', 'enum']);
/**
 * 어드민에 노출되는 attribute 정의.
 */
export const UserAttributeDefinitionSchema = z.object({
    id: z.string().uuid(),
    /** snake_case 식별자. API/매핑/룰에서 참조됨. 한 번 등록 후 변경 불가 (혼란 방지). */
    key: z.string().min(1).max(60),
    /** 사용자에게 보여지는 한글 라벨. */
    label: z.string().min(1).max(80),
    type: UserAttributeTypeSchema,
    /** type='enum' 일 때 선택지 (최소 1개). */
    options: z.array(z.string().min(1).max(80)).nullable(),
    required: z.boolean(),
    /** 일반 사용자의 사용자 검색(공유/그룹 화면) 결과에 이 속성을 노출할지. 기본 false. */
    showInDirectory: z.boolean(),
    sortOrder: z.number().int(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const UserAttributeDefinitionListSchema = z.object({
    definitions: z.array(UserAttributeDefinitionSchema),
});
/**
 * key 는 영문자/숫자/밑줄, 첫 글자는 영문자. SQL 키워드 충돌 회피.
 */
const KeySchema = z
    .string()
    .min(1)
    .max(60)
    .regex(/^[a-z][a-z0-9_]*$/, {
    message: 'key 는 소문자/숫자/밑줄만 가능하며 영문자로 시작해야 합니다.',
});
export const CreateUserAttributeRequestSchema = z
    .object({
    key: KeySchema,
    label: z.string().min(1).max(80),
    type: UserAttributeTypeSchema,
    options: z.array(z.string().min(1).max(80)).nullable().optional(),
    required: z.boolean().default(false),
    showInDirectory: z.boolean().default(false),
})
    .refine((v) => v.type !== 'enum' || (v.options && v.options.length > 0), {
    message: "type='enum' 인 경우 options 1개 이상 필수",
    path: ['options'],
});
export const UpdateUserAttributeRequestSchema = z.object({
    label: z.string().min(1).max(80).optional(),
    type: UserAttributeTypeSchema.optional(),
    options: z.array(z.string().min(1).max(80)).nullable().optional(),
    required: z.boolean().optional(),
    showInDirectory: z.boolean().optional(),
});
export const ReorderUserAttributesRequestSchema = z.object({
    ids: z.array(z.string().uuid()).min(1).max(200),
});
/**
 * 사용자 attribute 값. 타입별로 string | number | boolean | null (date 는 ISO string).
 * 서버는 정의된 type 으로 캐스팅 후 user_attribute_values 의 적절한 컬럼에 저장.
 */
export const UserAttributeValueSchema = z.union([z.string(), z.number(), z.boolean(), z.null()]);
/** key → value 매핑. 사용자 detail / create / update 에서 사용. */
export const UserAttributesRecordSchema = z.record(UserAttributeValueSchema);
//# sourceMappingURL=user-attributes.js.map